/* ============================================================
   La Nani — adaugare in cos din cardurile de produs
   Vezi theme/CLAUDE.md.

   Cardurile din colectie nu sunt formulare: peste ele sta un link
   care acopera tot cardul. Deci trimitem varianta direct la
   /cart/add.js si lasam drawer-ul Dawn sa se actualizeze singur,
   exact ca butonul principal de pe pagina de produs.
   ============================================================ */
(function () {
  'use strict';

  var SELECTOR = '[data-ln-add]';

  /* Cand fereastra de cos exista in pagina, adaugarea o face
     assets/la-nani-cos.js: adauga, arata fereastra si nu mai deschide
     sertarul lateral. Fisierul asta ramane doar pentru cazul in care
     fereastra lipseste — altfel s-ar adauga produsul de doua ori. */
  function fereastraPreiaTot() {
    return !!document.querySelector('[data-ln-cos]');
  }

  function actualizeazaContorul() {
    return fetch('/?sections=cart-icon-bubble')
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (sectiuni) {
        if (!sectiuni || !sectiuni['cart-icon-bubble']) return;
        var tinta = document.getElementById('cart-icon-bubble');
        if (!tinta) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = sectiuni['cart-icon-bubble'];
        /* endpointul intoarce <div id="shopify-section-cart-icon-bubble">…</div> */
        var proaspat = tmp.querySelector('#shopify-section-cart-icon-bubble') || tmp.firstElementChild;
        if (proaspat) tinta.innerHTML = proaspat.innerHTML;
      })
      .catch(function () {});
  }

  function adauga(id, btn) {
    var drawer = document.querySelector('cart-drawer');
    var body = new FormData();
    body.append('id', id);
    body.append('quantity', 1);
    if (drawer && drawer.getSectionsToRender) {
      body.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
      body.append('sections_url', window.location.pathname);
    }

    btn.disabled = true;
    var textInitial = btn.textContent;

    /* Meta: AddToCart cu handle-ul produsului */
    if (window.lnMeta) window.lnMeta.adaugaInCos({
      handle: btn.getAttribute('data-handle'),
      pret: parseFloat(btn.getAttribute('data-pret')),
      nume: btn.getAttribute('data-nume')
    });

    var adaugat = btn.getAttribute('data-added');

    fetch('/cart/add.js', {
      method: 'POST',
      body: body,
      headers: { 'Accept': 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function (json) {
        if (adaugat) {
          btn.textContent = adaugat;
          btn.classList.add('is-added');
          setTimeout(function () {
            btn.textContent = textInitial;
            btn.classList.remove('is-added');
          }, 1800);
        }
        btn.disabled = false;

        if (drawer && json && json.sections && drawer.renderContents) {
          /* Dawn scoate .is-empty doar de pe .drawer__inner, dar clasa sta
             si pe <cart-drawer>. O scoatem de pe amandoua, altfel continutul
             ramane ascuns cand cosul era gol la incarcarea paginii. */
          drawer.classList.remove('is-empty');
          var inner = drawer.querySelector('.drawer__inner');
          if (inner) inner.classList.remove('is-empty');
          drawer.renderContents(json);
          return;
        }
        return actualizeazaContorul();
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = textInitial;
        /* fara fetch functional, macar ducem omul in cos */
        window.location.href = '/cart';
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest(SELECTOR);
    if (!btn || !window.fetch) return;
    if (fereastraPreiaTot()) return;   /* vezi nota de sus */
    /* linkul care acopera cardul nu trebuie sa se declanseze */
    e.preventDefault();
    e.stopPropagation();
    var id = btn.getAttribute('data-variant');
    if (id) adauga(id, btn);
  });
})();
